import React, { useEffect, useState, useMemo } from "react";
import Coptyscript from "./Copyscript";
import GroupScript from "./Groupscript";
import CurrentScript from "./CurrentScript";
import {
  GetAllUserGroup,
  OpenPosition,
  getStrategyType,
  ScalpingPositionDetails,
  Option_Detail,
  GetSingleChart,
  GetUserScripts,
} from "../../CommonAPI/User";
import { GetGroupNames, GetAllGroupService } from "../../CommonAPI/Admin";
import FullDataTable from "../../../ExtraComponent/CommanDataTable";
import NoDataFound from "../../../ExtraComponent/NoDataFound";
import Content from "../../../ExtraComponent/Content";
import { FiPlusCircle } from "react-icons/fi";
import PillTabs from "../../../ExtraComponent/PillTabs";
import SuggestedBotCard from "./suggestedBotCard/SuggestedBotCard";
import { Container, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

const tabOptions = ["Scalping", "Option Strategy", "Pattern"];

const Userdashboard = () => {
  const userName = localStorage.getItem("name");
  const StrategyType = sessionStorage.getItem("StrategyType");
  const redirectStrategyType = sessionStorage.getItem("redirectStrategyType");
  const navigate = useNavigate();

  const addVia = sessionStorage.getItem("addVia");
  const [activeTab1, setActiveTab1] = useState("CurrentPosition");
  const [activeTab, setActiveTab] = useState(addVia || "currentScript");
  const [subTab, setSubTab] = useState(redirectStrategyType);
  const [refresh, setRefresh] = useState(false);
  const [getGroup, setGroup] = useState("");
  const [strategyType, setStrategyType] = useState([]);
  const [tableType, setTableType] = useState(StrategyType || "MultiCondition");
  const [data2, setData2] = useState({ status: true, msg: "Initial state" });
  const [suggestedBotdata, setSuggestedBotdata] = useState([]);
  const [FromDate, setFromDate] = useState(new Date());
  const [pillActiveTab, setPillActiveTab] = useState("Scalping");
  const [filteredSuggestedBotdata, setFilteredSuggestedBotdata] = useState([]);
  const [getAddScript, setAddScript] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [allScripts, setAllScripts] = useState({ data: [], len: 0 });

  const [strategyData, setStrategyData] = useState({
    parameters: {},
    Description: "",
  });
  const [optionStrategyData, setOptionStrategyData] = useState({
    parameters: {},
    Description: [],
  });
  const [patternStrategyData, setPatternStrategyData] = useState({
    parameters: {},
    Description: [],
  });

  const [ToDate, setToDate] = useState(() => {
    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  });
  const [getPositionData, setPositionData] = useState({
    loading: true,
    Scalping: [],
    Option: [],
    Pattern: [],
    NewScalping: [],

    ChartingData: [],
    GoldenData: [],
  });

  const currentDate = new Date();

  const tomorrow = new Date(currentDate);
  tomorrow.setDate(currentDate.getDate() + 1);

  const formatDate = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}.${month}.${day}`;
  };

  useEffect(() => {
    if (activeTab1 === "CurrentPosition") {
      fetchStrategyType();
    }
    if (activeTab1 === "OpenPosition") {
      GetOpenPosition();
    }
    if (activeTab1 === "SuggestedBots") {
      getSuggestedBotData();
    }
  }, [activeTab1]);

  useEffect(() => {
    getUserAllGroup();
  }, [activeTab]);

  useEffect(() => {
    setGroup("");
    sessionStorage.setItem("StrategyType", subTab);
    sessionStorage.removeItem("groupName");
  }, [subTab]);

  useEffect(() => {
    if (activeTab1 === "SuggestedBots") {
      setFilteredSuggestedBotdata(
        suggestedBotdata.filter((item) => item.StrategyType === pillActiveTab)
      );
    }
  }, [suggestedBotdata, pillActiveTab, activeTab1]);

  const GetUserAllScripts = async () => {
    const data = { Username: userName };
    await GetUserScripts(data)
      .then((response) => {
        if (response.Status) {
          setAllScripts({
            data: response?.data,
            len: response?.data?.length - 1,
          });
        } else {
          setAllScripts({
            data: [],
            len: 0,
          });
        }
      })
      .catch((err) => {
        console.log("Error in finding the User Scripts", err);
      });
  };

  const fetchStrategyType = async () => {
    try {
      const res = await getStrategyType({ name: userName });
      if (res.Data) {
        setStrategyType(res.Data);
        if (StrategyType) {
          setSubTab(StrategyType);
        } else {
          setSubTab(res.Data[0] || "ChartingPlatform");
        }
      }
    } catch (error) {
      console.log("Error in finding the strategy type", error);
    }
  };

  const getUserAllGroup = async () => {
    const data = { User: userName };
    await GetAllUserGroup(data)
      .then((response) => {
        if (response.Status) {
          setRefresh(!refresh);

          setData2({ status: true, msg: "Groups fetched successfully" });
        } else {
          setData2({
            status: false,
            msg: response.Message || "No groups found",
          });
        }
      })
      .catch((err) => {
        console.log("Error in finding the group name", err);
        setData2({ status: false, msg: "Error fetching groups" });
      });
  };

  const GetOpenPosition = async () => {
    const data = { userName: userName };
    await OpenPosition(data)
      .then((response) => {
        if (response.Status) {
          setPositionData({
            loading: false,
            Scalping: response.Scalping || [],
            Option: response.Option || [],
            Pattern: response.Pattern || [],
            NewScalping: response?.NewScalping || [],
            ChartingData: response?.ChartingData || [],
            GoldenData: response?.Golden || [],
          });
        } else {
          setPositionData({
            loading: false,
            Scalping: [],
            Option: [],
            Pattern: [],
            ChartingData: [],
          });
        }
      })
      .catch((err) => {
        console.log("Error in finding the open postion data", err);
      });
  };

  const columns2 = [
    {
      name: "S.No",
      label: "S.No",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          return rowIndex + 1;
        },
      },
    },
    {
      name: "STG",
      label: "Strategy",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Symbol",
      label: "Symbol",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "ETime",
      label: "Entry Time",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "EPrice",
      label: "Entry Price",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "LotSize",
      label: "Quantity",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Trade",
      label: "Trade",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Option Type",
      label: "Option Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Strike price",
      label: "Strike price",
      options: {
        filter: true,
        sort: true,
      },
    },

    {
      name: "Hashing",
      label: "Hashing",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "TradeType",
      label: "Transaction Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Target",
      label: "Target",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "SL",
      label: "Stop Loss",
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  const columns3 = [
    {
      name: "S.No",
      label: "S.No",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          return rowIndex + 1;
        },
      },
    },
    {
      name: "TradePattern",
      label: "Pattern Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "SPattern",
      label: "Pattern Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "PatternTime",
      label: "Pattern Time",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Symbol",
      label: "Symbol",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "ETime",
      label: "Entry Time",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "EPrice",
      label: "Entry Price",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "TradeType",
      label: "Transaction Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Quantity",
      label: "Lot",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Target",
      label: "Target",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "SL",
      label: "Stop Loss",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "TimeFrame",
      label: "Time Frame",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Trade",
      label: "Trade",
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  const columns4 = [
    {
      name: "S.No",
      label: "S.No",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          return rowIndex + 1;
        },
      },
    },
    {
      name: "ScalpType",
      label: "Target Type",
      options: {
        filter: true,
        sort: true,
      },
    },

    {
      name: "Symbol",
      label: "Symbol",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "ETime",
      label: "Entry Time",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "EPrice",
      label: "Entry Price",
      options: {
        filter: true,
        sort: true,
      },
    },

    {
      name: "TradeType",
      label: "Transaction Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Quantity",
      label: "Quantity",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Trade",
      label: "Trade",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Target",
      label: "Target",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "SL",
      label: "Re-entry",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "GroupN",
      label: "Unique Name",
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  const columns5 = [
    {
      name: "S.No",
      label: "S.No",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          return rowIndex + 1;
        },
      },
    },
    {
      name: "Symbol",
      label: "Symbol",
      options: {
        filter: true,
        sort: true,
      },
    },

    {
      name: "Token",
      label: "Token",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "ETime",
      label: "Entry Time",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "EPrice",
      label: "Entry Price",
      options: {
        filter: true,
        sort: true,
      },
    },

    {
      name: "TradeType",
      label: "Trade Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Quantity",
      label: "Quantity",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Trade",
      label: "Trade",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Target",
      label: "Target",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "SL",
      label: "Stop Loss",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Username",
      label: "Username",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Stretegy",
      label: "Stretegy",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "AccType",
      label: "Account Type",
      options: {
        filter: true,
        sort: true,
      },
    },

    {
      name: "Segmenttype",
      label: "Segment Type",
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  const columns6 = [
  {
    name: "S.No",
    label: "S.No",
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value, tableMeta) => {
        const rowIndex = tableMeta.rowIndex;
        return rowIndex + 1;
      },
    },
  },
  { name: "Exchange", label: "Exchange", options: { filter: true, sort: true } },
  { name: "Symbol", label: "Symbol", options: { filter: true, sort: true } },
  { name: "MainSymbol", label: "Main Symbol", options: { filter: true, sort: true } },
  { name: "Token", label: "Token", options: { filter: true, sort: true } },
  { name: "TradeType", label: "Trade Type", options: { filter: true, sort: true } },
  { name: "ETime", label: "Entry Time", options: { filter: true, sort: true } },
  { name: "EPrice", label: "Entry Price", options: { filter: true, sort: true } },
  { name: "ExitTime", label: "Exit Time", options: { filter: true, sort: true } },
  { name: "ExitPrice", label: "Exit Price", options: { filter: true, sort: true } },
  { name: "Quantity", label: "Quantity", options: { filter: true, sort: true } },
  { name: "Trade", label: "Trade", options: { filter: true, sort: true } },

  { name: "Target1", label: "Target 1", options: { filter: true, sort: true } },
  { name: "SL1", label: "Stop Loss 1", options: { filter: true, sort: true } },
  { name: "Target2", label: "Target 2", options: { filter: true, sort: true } },
  { name: "SL2", label: "Stop Loss 2", options: { filter: true, sort: true } },
  { name: "Target3", label: "Target 3", options: { filter: true, sort: true } },
  { name: "SL3", label: "Stop Loss 3", options: { filter: true, sort: true } },

  { name: "LotSize1", label: "Lot Size 1", options: { filter: true, sort: true } },
  { name: "LotSize2", label: "Lot Size 2", options: { filter: true, sort: true } },
  { name: "LotSize3", label: "Lot Size 3", options: { filter: true, sort: true } },
  { name: "LotCount", label: "Lot Count", options: { filter: true, sort: true } },

  { name: "Lot1SOE", label: "Lot1 SOE", options: { filter: true, sort: true } },
  { name: "Lot2SOE", label: "Lot2 SOE", options: { filter: true, sort: true } },
  { name: "Lot3SOE", label: "Lot3 SOE", options: { filter: true, sort: true } },

  { name: "FinalLot", label: "Final Lot", options: { filter: true, sort: true } },
  { name: "FinalTarget", label: "Final Target", options: { filter: true, sort: true } },
  { name: "FinalSL", label: "Final Stoploss", options: { filter: true, sort: true } },

  { name: "Option Type", label: "Option Type", options: { filter: true, sort: true } },
  { name: "Strike price", label: "Strike Price", options: { filter: true, sort: true } },
  { name: "Spot Price", label: "Spot Price", options: { filter: true, sort: true } },

  { name: "MOTrade", label: "MO Trade", options: { filter: true, sort: true } },
  { name: "MOPnL", label: "MO PnL", options: { filter: true, sort: true } },
  { name: "MCPnL", label: "MC PnL", options: { filter: true, sort: true } },

  { name: "Username", label: "Username", options: { filter: true, sort: true } },
  { name: "Strategy", label: "Strategy", options: { filter: true, sort: true } },

  { name: "Hashing", label: "Hashing", options: { filter: true, sort: true } },
  { name: "GroupN", label: "Group Name", options: { filter: true, sort: true } },
  { name: "CallExitTargettype", label: "Call Exit Target Type", options: { filter: true, sort: true } },
  { name: "PutExitTargettype", label: "Put Exit Target Type", options: { filter: true, sort: true } },
  { name: "CallExitSltype", label: "Call Exit SL Type", options: { filter: true, sort: true } },
  { name: "PutExitSltype", label: "Put Exit SL Type", options: { filter: true, sort: true } },
  { name: "Intraday Exit", label: "Intraday Exit", options: { filter: true, sort: true } },
  { name: "TradeExecution", label: "Trade Execution", options: { filter: true, sort: true } },
  { name: "TRColl", label: "Trade Collection", options: { filter: true, sort: true } },
  { name: "Product Type", label: "Product Type", options: { filter: true, sort: true } },
  { name: "Trading", label: "Trading", options: { filter: true, sort: true } },
  { name: "DeleteSignal", label: "Delete Signal", options: { filter: true, sort: true } },
  { name: "statusofExit", label: "Status of Exit", options: { filter: true, sort: true } },
  { name: "Dataid", label: "Data ID", options: { filter: true, sort: true } },
];


  const getSuggestedBotData = async () => {
    try {
      if (activeTab1 === "SuggestedBots") {
        const res = await GetGroupNames();
        if (res.Status) {
          setSuggestedBotdata(res.Data);
        } else {
          setSuggestedBotdata([]);
        }
       
      }
    } catch (error) {
      console.error("Error fetching suggested bot data:", error);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleViewDetails = async (title) => {
    try {
      const req = {
        Group: title,
        Strategy: pillActiveTab,
      };

      if (pillActiveTab === "Scalping") {
        const res = await GetAllGroupService(req);
        if (res.Status) {
          setStrategyData((prev) => ({
            ...prev,
            parameters: res.Data?.[0],
          }));
        }
        const req2 = {
          PositionType: res.Data?.[0]?.FixedSM,
        };
        const res2 = await ScalpingPositionDetails(req2);
        if (res2.status) {
          setStrategyData((prev) => ({
            ...prev,
            Description:
              res2.data?.[0]?.Description || "No description available",
          }));
        }
      } else if (pillActiveTab === "Option Strategy") {
        const res = await GetAllGroupService(req);

        if (res.Status) {
          setOptionStrategyData((prev) => ({
            ...prev,
            parameters: res.Data?.[0],
          }));

          const req2 = {
            StrategyName: res.Data?.[0]?.STG,
          };
          const res2 = await Option_Detail(req2);
          if (res2.status) {
            setOptionStrategyData((prev) => ({
              ...prev,
              Description: res2?.data[0],
            }));
          }
        }
      } else if (pillActiveTab === "Pattern") {
        const res = await GetAllGroupService(req);
        if (res.Status) {
          setPatternStrategyData((prev) => ({
            ...prev,
            parameters: res.Data?.[0],
          }));

          const req2 = {
            Pattern: res.Data?.[0]?.Pattern,
            PatternType: "CandleStick Pattern",
            TType: "",
          };
          const res2 = await GetSingleChart(req2);
          if (res2.status) {
            setPatternStrategyData((prev) => ({
              ...prev,
              Description: res2?.data[0],
            }));
          }
        }
      }

      setShowDetailsModal(true);
    } catch (error) {
      console.error("Error in handleViewDetails:", error);
    }
  };

  const handleAddToScript = async () => {
    try {
      if (pillActiveTab === "Scalping") {
        handleAddScript1(strategyData.parameters, 2);
      } else if (pillActiveTab === "Option Strategy") {
        handleAddScript2(optionStrategyData.parameters);
      } else if (pillActiveTab === "Pattern") {
        handleAddScript3(patternStrategyData.parameters);
      }
    } catch (error) {
      console.error("Error in handleAddToScript:", error);
    }
  };

  const handleAddScript1 = (data1, type) => {
    if (allScripts?.data?.[allScripts?.len]?.CombineScalping?.length == 0) {
      Swal.fire({
        title: "Warning",
        text: "You don't have any valid plan to use this strategy",
        icon: "warning",
        timer: 1500,
        timerProgressBar: true,
      });
    } else {
      const isExist =
        allScripts?.data?.[allScripts?.len]?.CombineScalping?.find(
          (item) => item === data1?.ScalpType
        ) ?? "";
      if (!isExist) {
        Swal.fire({
          title: "Warning",
          text: "This script is not available for you",
          icon: "warning",
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }
      const data = {
        selectGroup: strategyData.parameters?.Group,
        selectStrategyType: "Scalping",
        type: "group",
        ...data1,
      };
      navigate("/user/addscript/scalping", {
        state: { data: data, scriptType: allScripts },
      });
    }
  };

  const handleAddScript2 = (data1) => {
    if (allScripts.data.length == 0) {
      Swal.fire({
        title: "Warning",
        text: "You don't have any valid plan to use this strategy",
        icon: "warning",
        timer: 1500,
        timerProgressBar: true,
      });
    } else {
      let OptionStgArr = allScripts?.data[allScripts?.len]?.CombineOption;

      if (
        (OptionStgArr?.includes("Straddle_Strangle") &&
          [
            "ShortStrangle",
            "LongStrangle",
            "LongStraddle",
            "ShortStraddle",
          ]?.includes(data1?.STG)) ||
        (OptionStgArr?.includes("Butterfly_Condor") &&
          [
            "LongIronButterfly",
            "ShortIronButterfly",
            "LongIronCondor",
            "ShortIronCondor",
          ]?.includes(data1?.STG)) ||
        (OptionStgArr?.includes("Spread") &&
          [
            "BearCallSpread",
            "BearPutSpread",
            "BullCallSpread",
            "BullPutSpread",
          ]?.includes(data1?.STG)) ||
        (OptionStgArr?.includes("Ladder_Coverd") &&
          [
            "BullCallLadder",
            "BullPutLadder",
            "CoveredCall",
            "CoveredPut",
          ]?.includes(data1?.STG)) ||
        (OptionStgArr?.includes("Collar_Ratio") &&
          [
            "LongCollar",
            "ShortCollar",
            "RatioCallSpread",
            "RatioPutSpread",
          ]?.includes(data1?.STG)) ||
        (OptionStgArr?.includes("Shifting_FourLeg") &&
          [
            "LongFourLegStretegy",
            "ShortShifting",
            "LongShifting",
            "ShortFourLegStretegy",
          ]?.includes(data1?.STG))
      ) {
        const data = {
          selectGroup: optionStrategyData.parameters?.Group,
          selectStrategyType: "Option Strategy",
          type: "copy",
          ...data1,
        };
        navigate("/user/addscript/option", {
          state: { data: data, scriptType: allScripts },
        });
      } else {
        Swal.fire({
          title: "Warning",
          text: "This script is not available for you",
          icon: "warning",
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }
    }
  };

  const handleAddScript3 = (data1) => {
    if (allScripts.data.length == 0) {
      Swal.fire({
        title: "Warning",
        text: "You don't have any valid plan to use this strategy",
        icon: "warning",
        timer: 1500,
        timerProgressBar: true,
      });
    } else {
      const isExist =
        allScripts?.data[allScripts?.len]?.CombinePattern?.find(
          (item) => item === data1?.TradePattern
        ) ?? "";
      if (!isExist) {
        Swal.fire({
          title: "Warning",
          text: "This script is not available for you",
          icon: "warning",
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }
      const data = {
        selectGroup: patternStrategyData.parameters?.Group,
        selectStrategyType: "Pattern",
        type: "group",
        ...data1,
      };
      navigate("/user/addscript/pattern", {
        state: { data: data, scriptType: allScripts },
      });
    }
  };
  useEffect(() => {
    GetUserAllScripts();
  }, []);
  return (
    <Content
      Page_title="📊 User Dashboard"
      button_status={false}
      backbutton_status={false}
    >
      {/* Breadcrumb */}
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item active " aria-current="page">
            Dashboard
          </li>
        </ol>
      </nav>

      <div className="">
        {/* Top Tabs */}
        <ul
          className="nav nav-tabs rounded-0 w-100 "
          id="myTab-2"
          role="tablist"
        >
          <li className="nav-item">
            <a
              className={`nav-link ${
                activeTab1 === "CurrentPosition" ? "active" : ""
              }`}
              onClick={() => setActiveTab1("CurrentPosition")}
            >
              Current Script
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ms-8 ${
                activeTab1 === "OpenPosition" ? "active" : ""
              }`}
              onClick={() => setActiveTab1("OpenPosition")}
            >
              Open Position
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ms-8 ${
                activeTab1 === "SuggestedBots" ? "active" : ""
              }`}
              onClick={() => setActiveTab1("SuggestedBots")}
            >
              Suggested Bots
            </a>
          </li>
        </ul>

        {/* Current Position Section */}
        {activeTab1 === "CurrentPosition" && (
          <div>
            <div className="d-lg-flex align-items-center justify-content-lg-between gap-3 mt-2">
              {/* Desktop Pills */}
              {!isMobile && (
                <ul className="nav nav-pills l p-1 d-flex flex-wrap mb-0">
                  {strategyType.map((type, index) => (
                    <li className="nav-item" key={index}>
                      <button
                        className={`nav-link ${
                          subTab === type.trim() ? "active" : ""
                        }`}
                        style={{
                          padding: "6px 14px",
                          margin: "5px",
                          border: "none",
                          outline: "none",
                        }}
                        onClick={() => {
                          setSubTab(type.trim());
                          setGroup("");
                          sessionStorage.setItem("StrategyType", type.trim());
                          sessionStorage.removeItem("groupName");
                        }}
                      >
                        <FiPlusCircle className="me-1" /> {type} Bot
                      </button>
                    </li>
                  ))}
                </ul>
              )}

              {/* Add Script / Signals */}
              <button className="addbtn btn " onClick={() => setAddScript(subTab)}>
                {subTab === "ChartingPlatform" ? "Signals" : "Add Script"}
              </button>
            </div>

            {/* Tab Content */}
            <div className="mt-4">
              {activeTab === "group" ? (
                <div className="tab-pane fade show active">
                  {subTab &&
                    (getGroup === "copyScript" ? (
                      <Coptyscript
                        data={subTab}
                        selectedType={activeTab}
                        data2={data2}
                        FromDate={formatDate(FromDate)}
                        ToDate={formatDate(ToDate)}
                      />
                    ) : (
                      <GroupScript
                        data={subTab}
                        selectedType={activeTab}
                        GroupName={getGroup}
                        data2={data2}
                      />
                    ))}
                </div>
              ) : (
                activeTab === "currentScript" && (
                  <div className="tab-pane fade show active">
                    {subTab && (
                      <CurrentScript
                        tableType={tableType}
                        data={subTab}
                        selectedType={activeTab}
                        FromDate={formatDate(FromDate)}
                        ToDate={formatDate(ToDate)}
                        alignDates="right"
                        getAddScript={getAddScript}
                      />
                    )}

                    {getGroup && (
                      <GroupScript
                        data={subTab}
                        selectedType={activeTab}
                        GroupName={getGroup}
                        data2={data2}
                        getGroup={getGroup}
                      />
                    )}
                  </div>
                )
              )}
            </div>
          </div>
        )}

        {/* Open Position Section */}
        {activeTab1 === "OpenPosition" && (
          <>
            {getPositionData.NewScalping?.length > 0 && (
              <>
                <h4 className="mt-3">Scalping</h4>
                <FullDataTable
                  columns={columns4}
                  data={getPositionData.NewScalping}
                  checkBox={false}
                  alignDates="right"
                />
              </>
            )}

            {getPositionData.Option?.length > 0 && (
              <div className="mt-4">
                <h4>Option</h4>
                <FullDataTable
                  columns={columns2}
                  data={getPositionData.Option}
                  checkBox={false}
                  alignDates="right"
                />
              </div>
            )}

            {getPositionData.Pattern?.length > 0 && (
              <div className="mt-4">
                <h4>Pattern</h4>
                <FullDataTable
                  columns={columns3}
                  data={getPositionData.Pattern}
                  checkBox={false}
                  alignDates="right"
                />
              </div>
            )}

            {getPositionData.GoldenData?.length > 0 && (
              <div className="mt-4">
                <h4>Golden </h4>
                <FullDataTable
                  columns={columns6}
                  data={getPositionData.GoldenData}
                  checkBox={false}
                  alignDates="right"
                />
              </div>
            )}

            {getPositionData.ChartingData?.length > 0 && (
              <div className="mt-4">
                <h4>Charting Platform</h4>
                <FullDataTable
                  columns={columns5}
                  data={getPositionData.ChartingData}
                  checkBox={false}
                  alignDates="right"
                />
              </div>
            )}

            {/* If no data */}
            {getPositionData.Scalping?.length === 0 &&
              getPositionData.NewScalping?.length === 0 &&
              getPositionData.Option?.length === 0 &&
              getPositionData.Pattern?.length === 0 &&
              getPositionData.GoldenData?.length === 0 &&
              getPositionData.ChartingData?.length === 0 && <NoDataFound />}
          </>
        )}

        {/* Suggested Bots Section */}
        {activeTab1 === "SuggestedBots" && (
          <>
            <PillTabs
              tabs={tabOptions}
              activeTab={pillActiveTab}
              setActiveTab={setPillActiveTab}
            />
            {filteredSuggestedBotdata.length === 0 ? (
              <NoDataFound />
            ) : (
              <div className="py-4 mt-4">
                <Row className="g-4">
                  {filteredSuggestedBotdata.map((strategy, index) => (
                    <Col xs={12} sm={6} md={4} key={index}>
                      <SuggestedBotCard
                        title={strategy.GroupName}
                        strategyType={strategy.StrategyType}
                        description={strategy.Message}
                        onViewDetails={() =>
                          handleViewDetails(strategy.GroupName)
                        }
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            )}
          </>
        )}
      </div>

      {showDetailsModal && (
        <div
          className="custom-modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(30, 41, 59, 0.7)",
            zIndex: 1050,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className={"custom-modal-content card-bg-color card-text-Color"}
            style={{
              background: "#fff",
              borderRadius: "18px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              maxWidth: 600,
              width: "95%",
              padding: 0,
              position: "relative",
              display: "flex",
              flexDirection: "column",
              maxHeight: "75vh",
            }}
          >
            <div
              style={{
                padding: "2.5rem 2rem 0.5rem 2rem",
                position: "relative",
                flex: "0 0 auto",
              }}
            >
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                style={{ position: "absolute", top: 18, right: 18, zIndex: 2 }}
                onClick={() => {
                  setShowDetailsModal(false);
                  setStrategyData({ parameters: {}, Description: "" });
                  setOptionStrategyData({ parameters: {}, Description: [] });
                }}
              ></button>

              <h3
                className="fw-bold mb-3"
                style={{ color: "#1e293b", letterSpacing: "0.5px" }}
              >
                Strategy Details
              </h3>
              <hr style={{ margin: "0 0 1.5rem 0", borderColor: "#e2e8f0" }} />
            </div>
            <div
              style={{
                maxHeight: "45vh",
                overflowY: "auto",
                padding: "0 2rem 0 2rem",
                flex: "1 1 auto",
              }}
            >
              {pillActiveTab === "Option Strategy" &&
              optionStrategyData.Description &&
              Object.keys(optionStrategyData.Description).length > 0 ? (
                <div>
                  {/* Option Strategy Image */}
                  {optionStrategyData.Description.image_data && (
                    <div className="text-center mb-3">
                      <img
                        src={`data:image/png;base64,${optionStrategyData.Description.image_data}`}
                        alt="Strategy"
                        style={{
                          maxWidth: "100%",
                          maxHeight: 260,
                          borderRadius: 10,
                          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        }}
                      />
                    </div>
                  )}
                  {/* Pattern Details if present */}
                  {optionStrategyData.Description.Pattern && (
                    <div className="">
                      <h5 className="fw-bold" style={{ color: "#0ea5e9" }}>
                        Pattern Details
                      </h5>
                      <div className="mb-2">
                        <b>Pattern Type:</b>{" "}
                        {optionStrategyData.Description.PatternType}
                      </div>
                      <div className="mb-2">
                        <b>Pattern:</b> {optionStrategyData.Description.Pattern}
                      </div>
                      <div className="mb-2">
                        <b>Description:</b>{" "}
                        {optionStrategyData.Description.Description}
                      </div>
                      <div className="mb-2">
                        <b>Trade Type:</b>{" "}
                        {optionStrategyData.Description.TType}
                      </div>
                    </div>
                  )}
                  <h4 className="fw-bold mb-2" style={{ color: "#0ea5e9" }}>
                    {optionStrategyData.Description["Strategy Name"]}
                  </h4>
                  <div className="mb-2">
                    <b>Market Outlook:</b>{" "}
                    {optionStrategyData.Description["View (Market Outlook)"]}
                  </div>
                  <div className="mb-2">
                    <b>Strategy:</b>{" "}
                    {optionStrategyData.Description["Strategy"]}
                  </div>
                  <div className="mb-2">
                    <b>Risk (Max Loss):</b>{" "}
                    {optionStrategyData.Description["Risk (Max Loss)"]}
                  </div>
                  <div className="mb-2">
                    <b>Reward (Max Profit):</b>{" "}
                    {optionStrategyData.Description["Reward (Max Profit)"]}
                  </div>
                  <div className="mb-2">
                    <b>Breakeven Points:</b> <br />
                    <span className="ms-3">
                      Upper BE:{" "}
                      {
                        optionStrategyData.Description["Breakeven Points"]?.[
                          "Upper BE"
                        ]
                      }
                    </span>
                    <br />
                    <span className="ms-3">
                      Lower BE:{" "}
                      {
                        optionStrategyData.Description["Breakeven Points"]?.[
                          "Lower BE"
                        ]
                      }
                    </span>
                  </div>
                  <div className="mb-2">
                    <b>Max Profit When?</b>
                    <br />
                    <span className="ms-3">
                      Upward:{" "}
                      {
                        optionStrategyData.Description["Max Profit When?"]
                          ?.Upward
                      }
                    </span>
                    <br />
                    <span className="ms-3">
                      Downward:{" "}
                      {
                        optionStrategyData.Description["Max Profit When?"]
                          ?.Downward
                      }
                    </span>
                  </div>
                  <div className="mb-2">
                    <b>Max Loss When?</b>{" "}
                    {optionStrategyData.Description["Max Loss When?"]}
                  </div>
                  {/* Parameters Section */}
                  <div className="mt-4">
                    <h5 className="fw-bold" style={{ color: "#0ea5e9" }}>
                      Parameters
                    </h5>
                    <div className="container-fluid">
                      <div className="row g-3">
                        {[
                          {
                            label: "Option type",
                            value: optionStrategyData.parameters?.STG,
                          },
                          {
                            label: "Risk Handle",
                            value: optionStrategyData.parameters?.Targettype,
                          },
                          {
                            label: "Symbol",
                            value: optionStrategyData.parameters?.Symbol,
                          },
                          {
                            label: "Expiry Type",
                            value: optionStrategyData.parameters?.Expirytype,
                          },
                          {
                            label: "Measurement Type",
                            value: optionStrategyData.parameters?.strategytype,
                          },
                          {
                            label: "Target",
                            value:
                              optionStrategyData.parameters?.["Target value"],
                          },
                          {
                            label: "Stoploss",
                            value: optionStrategyData.parameters?.["SL value"],
                          },
                          {
                            label: "Trade execution",
                            value:
                              optionStrategyData.parameters?.TradeExecution,
                          },
                          {
                            label: "Lot",
                            value: optionStrategyData.parameters?.["Lot Size"],
                          },
                          {
                            label: "Exit Day",
                            value:
                              optionStrategyData.parameters?.["Product Type"],
                          },
                          {
                            label: "Entry Time",
                            value:
                              optionStrategyData.parameters?.["Entry Time"],
                          },
                          {
                            label: "Exit Time",
                            value: optionStrategyData.parameters?.["Exit Time"],
                          },
                          {
                            label: "Strike Type",
                            value: optionStrategyData.parameters?.StrikeType,
                          },
                        ].map((item, idx) => (
                          <div className="col-md-6" key={idx}>
                            <div className=" ">
                              <label
                                className="form-label fw-semibold"
                                style={{ color: "#334155" }}
                              >
                                {item.label}
                              </label>
                              <input
                                type="text"
                                className="form-control bg-light border-0 text-dark fw-semibold"
                                value={item.value || "N/A"}
                                disabled
                                style={{ borderRadius: "8px" }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ) : pillActiveTab === "Pattern" &&
                patternStrategyData.Description &&
                Object.keys(patternStrategyData.Description).length > 0 ? (
                <div>
                  {/* Pattern Image */}
                  {patternStrategyData.Description.image_data && (
                    <div className="text-center mb-3">
                      <img
                        src={`data:image/png;base64,${patternStrategyData.Description.image_data}`}
                        alt="Pattern"
                        style={{
                          maxWidth: "100%",
                          maxHeight: 260,
                          borderRadius: 10,
                          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        }}
                      />
                    </div>
                  )}
                  <h4 className="fw-bold mb-2" style={{ color: "#0ea5e9" }}>
                    {patternStrategyData.Description.Pattern}
                  </h4>
                  <div className="mb-2">
                    <b>Pattern Type:</b>{" "}
                    {patternStrategyData.Description.PatternType}
                  </div>
                  <div className="mb-2">
                    <b>Description:</b>{" "}
                    {patternStrategyData.Description.Description}
                  </div>
                  <div className="mb-2">
                    <b>Trade Type:</b> {patternStrategyData.Description.TType}
                  </div>
                  {/* Pattern Parameters Section */}
                  <div className="mt-4">
                    <h5 className="fw-bold" style={{ color: "#0ea5e9" }}>
                      Parameters
                    </h5>
                    <div className="container-fluid">
                      <div className="row g-3">
                        {[
                          {
                            label: "Pattern Name",
                            value: patternStrategyData.parameters?.TradePattern,
                          },
                          {
                            label: "Pattern Type",
                            value: patternStrategyData.parameters?.Pattern,
                          },
                          {
                            label: "Symbol",
                            value: patternStrategyData.parameters?.Symbol,
                          },
                          {
                            label: "Trade type",
                            value: patternStrategyData.parameters?.TType,
                          },
                          {
                            label: "Quantity",
                            value: patternStrategyData.parameters?.Quantity,
                          },
                          {
                            label: "Time Frame",
                            value: patternStrategyData.parameters?.TimeFrame,
                          },
                          {
                            label: "Measurement type",
                            value: patternStrategyData.parameters?.TStype,
                          },
                          {
                            label: "Target",
                            value:
                              patternStrategyData.parameters?.["Target value"],
                          },
                          {
                            label: "Stoploss",
                            value: patternStrategyData.parameters?.["SL value"],
                          },
                          {
                            label: "Trade Execution",
                            value:
                              patternStrategyData.parameters?.TradeExecution,
                          },
                          {
                            label: "Exit Day",
                            value: patternStrategyData.parameters?.ExitDay,
                          },
                          {
                            label: "Entry Time",
                            value: patternStrategyData.parameters?.EntryTime,
                          },
                          {
                            label: "Exit Time",
                            value: patternStrategyData.parameters?.ExitTime,
                          },
                          // { label: "Strike Type", value: patternStrategyData.parameters?.["Strike Price"] },
                        ].map((item, idx) => (
                          <div className="col-md-6" key={idx}>
                            <div className=" ">
                              <label
                                className="form-label fw-semibold"
                                style={{ color: "#334155" }}
                              >
                                {item.label}
                              </label>
                              <input
                                type="text"
                                className="form-control bg-light border-0 text-dark fw-semibold"
                                value={item.value || "N/A"}
                                disabled
                                style={{ borderRadius: "8px" }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ) : pillActiveTab === "Scalping" && strategyData.Description ? (
                <div>
                  <h4 className="fw-bold mb-2" style={{ color: "#0ea5e9" }}>
                    Description
                  </h4>
                  <div
                    className="mb-3 card-text-Color"
                    style={{
                      whiteSpace: "pre-line",
                      color: "#334155",
                      fontSize: "1rem",
                    }}
                  >
                    {strategyData.Description}
                  </div>
                  {/* Parameters Section for Scalping */}
                  <div className="mt-4">
                    <h5 className="fw-bold" style={{ color: "#0ea5e9" }}>
                      Parameters
                    </h5>
                    <div className="container-fluid">
                      <div className="row g-3">
                        {[
                          {
                            label: "Symbol",
                            value: strategyData.parameters?.Symbol,
                          },
                          // { label: "Trading Type", value: strategyData.parameters?.Trading },
                          {
                            label: "Trade Type",
                            value: strategyData.parameters?.TType,
                          },
                          {
                            label: "Measurement Type",
                            value: strategyData.parameters?.TStype,
                          },
                          {
                            label: "Target",
                            value: strategyData.parameters?.["Booking Point"],
                          },
                          {
                            label: "Re-entry",
                            value: strategyData.parameters?.["Re-entry Point"],
                          },
                          {
                            label: "Lot",
                            value: strategyData.parameters?.Quantity,
                          },
                          {
                            label: "Exit Day",
                            value: strategyData.parameters?.ExitDay,
                          },
                          {
                            label: "Entry Time",
                            value: strategyData.parameters?.EntryTime,
                          },
                          {
                            label: "Exit Time",
                            value: strategyData.parameters?.ExitTime,
                          },
                          {
                            label: "Trade Execution",
                            value: strategyData.parameters?.TradeExecution,
                          },
                          {
                            label: "Target Selection",
                            value: strategyData.parameters?.Targetselection,
                          },
                        ].map((item, idx) => (
                          <div className="col-md-6" key={idx}>
                            <div className=" ">
                              <label
                                className="form-label fw-semibold"
                                style={{ color: "#334155" }}
                              >
                                {item.label}
                              </label>
                              <input
                                type="text"
                                className="form-control bg-light border-0 text-dark fw-semibold"
                                value={item.value || "N/A"}
                                disabled
                                style={{ borderRadius: "8px" }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="alert alert-info">
                  No description available.
                </div>
              )}
            </div>
            <div
              className="d-flex justify-content-end mt-4"
              style={{ padding: "0 2rem 2rem 2rem", flex: "0 0 auto" }}
            >
              <button
                type="button"
                className="addbtn btn px-3 py-1 rounded-pill me-2"
                style={{ fontSize: "0.95rem" }}
                onClick={() => {
                  // TODO: Add your logic for adding to script here
                  handleAddToScript();
                }}
              >
                Add to script
              </button>
              <button
                type="button"
                className="btn btn-outline-primary px-3 py-1"
                style={{ fontSize: "0.95rem" }}
                onClick={() => {
                  setShowDetailsModal(false);
                  setStrategyData({ parameters: {}, Description: "" });
                  setOptionStrategyData({ parameters: {}, Description: [] });
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </Content>
  );
};

export default Userdashboard;
